"use client";

import { useTranslations } from "next-intl";

interface LoadingProps {
  message?: string;
  variant?: "fullscreen" | "container" | "inline";
  size?: "sm" | "md" | "lg";
}

export default function Loading({
  message,
  variant = "fullscreen",
  size = "md",
}: LoadingProps) {
  const t = useTranslations("common");
  const displayMessage = message ?? t("loading");

  const spinnerSizes = {
    sm: "w-6 h-6",
    md: "w-12 h-12",
    lg: "w-16 h-16",
  };

  const layoutClasses = {
    fullscreen:
      "min-h-screen bg-bg flex flex-col items-center justify-center relative overflow-hidden",
    container:
      "flex flex-col items-center justify-center py-20 bg-bg rounded-lg min-h-[400px]",
    inline: "flex items-center justify-center gap-3 py-8",
  };

  // Spinner de marca: acento sobre fondo `bg` (ADR-004 §10, solo tokens — sin colores sueltos).
  const spinnerClass = `${spinnerSizes[size]} rounded-full border-4 border-accent border-t-transparent animate-spin`;

  if (variant === "inline") {
    return (
      <div className={layoutClasses[variant]}>
        <div className={spinnerClass}></div>
        <p className="text-muted text-sm">{displayMessage}</p>
      </div>
    );
  }

  return (
    <div className={layoutClasses[variant]}>
      <div className={spinnerClass}></div>
      <p className="mt-4 text-ink">{displayMessage}</p>
    </div>
  );
}
